export default __webpack_public_path__ + "static/media/visa.6bab9800.svg";